export default () => ({
  init() {
    setTimeout(() => {
      if (!this.hasSeen()) {
        this.opened = true
        document.body.style.overflow = 'hidden'
      }
    }, 100)
  },
  opened: false,
  cookieName: 'transition-seen',
  close() {
    this.setSeen()
    this.opened = false
    document.body.style.overflow = 'initial'
  },
  hasSeen() {
    return localStorage.getItem(this.cookieName) !== null
  },
  setSeen() {
    localStorage.setItem(this.cookieName, '1')
  }
})
